<footer class="it-footer mt-5" id="footer">
    <div class="it-footer-main">
        <div class="container">
            <section class="px-0">
                <div class="row">
                    <div class="col-12 footer-items-wrapper logo-wrapper">
                        <div class="it-brand-wrapper">
                            <a href="/">
                                <picture>
                                    <img
                                        src="../assets/img/logo-bianco.svg"
                                        title="{{ 'it.portal.ras.alt-img' | translate }}"
                                        alt="{{ 'it.portal.ras.alt-img' | translate }}"
                                        height="72"
                                    />
                                </picture>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <section class="px-0 pb-4">
                <div class="row">
                    <div class="col-md-6 footer-items-wrapper">
                        <h4 class="h4 footer-heading-title">
                            <a>{{ "it.footer.contatti" | translate }}</a>
                        </h4>
                        <hr />
                        <p class="lh-sm fs-6" [innerHtml]="'it.footer.servizio' | translate"></p>
                        <p class="lh-sm fs-6">
                            <span [innerHtml]="'it.footer.indirizzo' | translate"></span>
                            <span [innerHtml]="'it.footer.email' | translate"></span>
                            <span [innerHtml]="'it.footer.pec' | translate"></span>
                        </p>
                    </div>
                    <div class="col-md-3 footer-items-wrapper">
                        <h4 class="h4 footer-heading-title">
                            <a class="invisible">{{ "it.footer.link" | translate }}</a>
                        </h4>
                        <hr />
                        <div class="link-list-wrapper">
                            <ul class="footer-list link-list">
                                <li>
                                    <a
                                        class="list-item"
                                        href="https://www.regione.sardegna.it/privacy/privacy-policy"
                                        target="_blank"
                                        title="{{ 'it.portal.goto-page' | translate }}: {{
                                            'it.footer.links.privacy' | translate
                                        }}"
                                    >
                                        {{ "it.footer.links.privacy" | translate }}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        class="list-item"
                                        href="https://www.regione.sardegna.it/note-legali"
                                        target="_blank"
                                        title="{{ 'it.portal.goto-page' | translate }}: {{
                                            'it.footer.links.note-legali' | translate
                                        }}"
                                    >
                                        {{ "it.footer.links.note-legali" | translate }}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        class="list-item"
                                        href="https://www.regione.sardegna.it/accessibilita"
                                        target="_blank"
                                        title="{{ 'it.footer.links.accessibilita' | translate }}"
                                    >
                                        {{ "it.footer.links.accessibilita" | translate }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-3 footer-items-wrapper">
                        <h4 class="h4 footer-heading-title">
                            <a>{{ "it.footer.seguici" | translate }}</a>
                        </h4>
                        <hr />
                        <ul class="list-inline text-left social">
                            <li class="list-inline-item">
                                <a href="https://api.whatsapp.com/send?phone=393316096820" target="_blank">
                                    <it-icon name="whatsapp" class="bg-dark" color="white" size="sm"></it-icon>
                                    <span class="visually-hidden">{{ "it.footer.social.whatsapp" | translate }}</span>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a href="https://www.facebook.com/regioneautonomasardegna/" target="_blank">
                                    <it-icon name="facebook" class="bg-dark" color="white" size="sm"></it-icon>
                                    <span class="visually-hidden">{{ "it.footer.social.facebook" | translate }}</span>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a href="https://www.instagram.com/regioneautonomasardegna/" target="_blank">
                                    <it-icon name="instagram" class="bg-dark" color="white" size="sm"></it-icon>
                                    <span class="visually-hidden">{{ "it.footer.social.instagram" | translate }}</span>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a
                                    href="https://www.linkedin.com/company/regione-autonoma-della-sardegna/"
                                    target="_blank"
                                >
                                    <it-icon name="linkedin" class="bg-dark" color="white" size="sm"></it-icon>
                                    <span class="visually-hidden">{{ "it.footer.social.linkedin" | translate }}</span>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a href="https://www.youtube.com/channel/UCM10wX8iwOQUwWxPK4UfG4A" target="_blank">
                                    <it-icon name="youtube" class="bg-dark" color="white" size="sm"></it-icon>
                                    <span class="visually-hidden">{{ "it.footer.social.youtube" | translate }}</span>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a href="https://www.tiktok.com/@regioneautonomasardegna" target="_blank">
                                    <it-icon name="tiktok" class="bg-dark" color="white" size="sm"></it-icon>
                                    <span class="visually-hidden">{{ "it.footer.social.tiktok" | translate }}</span>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a href="https://twitter.com/Reg_Sardegna" target="_blank">
                                    <it-icon name="twitter" class="bg-dark" color="white" size="sm"></it-icon>
                                    <span class="visually-hidden">{{ "it.footer.social.twitter" | translate }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section class="px-0">
                <div class="row">
                    <div class="col-md-12 footer-items-wrapper">
                        <hr />
                        <p class="fs-6">© {{ currentYear }} {{ "it.portal.ras.name" | translate }}</p>
                    </div>
                </div>
            </section>
        </div>
    </div>
</footer>
